import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/.netlify/functions/auth-login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Login failed');
        return;
      }
      localStorage.setItem('marinelink_owner_token', data.token);
      localStorage.setItem('marinelink_owner_listing', JSON.stringify(data.listing));
      navigate('/dashboard');
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-[440px] mx-auto px-4 md:px-8 py-6 md:py-12 pb-24">
      <div className="flex items-center gap-2 text-sm text-text-muted mb-4">
        <Link to="/" className="text-text-secondary hover:text-accent transition-colors">Home</Link>
        <span>/</span>
        <span>Sign in</span>
      </div>
      <h1 className="font-display text-2xl md:text-[1.8rem] font-bold mb-2">Business Owner Sign In</h1>
      <p className="text-text-secondary mb-6 text-sm">
        Manage your MarineLink listing. Use the email address associated with your listing.
      </p>

      {error && (
        <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-3 mb-4 text-sm text-red-700 dark:text-red-300">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-xs font-semibold text-text-secondary mb-2">Email</label>
          <input
            className="form-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@business.co.nz"
            autoComplete="email"
          />
        </div>
        <div>
          <label className="block text-xs font-semibold text-text-secondary mb-2">Password</label>
          <input
            className="form-input"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            autoComplete="current-password"
          />
        </div>
        <button type="submit" disabled={loading} className="btn btn-primary btn-lg btn-block">
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>

      <div className="mt-6 text-center">
        <Link to="/forgot-password" className="text-sm text-accent hover:underline">
          Forgot password?
        </Link>
      </div>

      <div className="mt-8 bg-card-light dark:bg-card border border-[rgba(79,179,217,0.14)] rounded-lg p-4">
        <h2 className="font-semibold text-sm mb-2">Don't have an account yet?</h2>
        <p className="text-text-secondary text-xs mb-3">
          If your business is already listed on MarineLink, use the "Forgot password" link above to set your password and activate your account.
        </p>
        <Link to="/list" className="btn btn-ghost btn-sm">List your business</Link>
      </div>
    </div>
  );
}
